export default {
  title: 'Streamline Your Workflows with Document Automation | Anvil',
  description:
    "Discover Anvil's document automation solutions from data collection to PDF generation and e-sign solutions. Enhance your workflow now.",
  keywords: 'e-sign,e-signatures,pdf,pdf api,pdf workflow,e-signature api',
  socialTagline: '',
}
